export const ecommerceTypography = {
  useNextVariants: true,
  fontFamily: "Circular",

  h1: {
    fontFamily: "Circular",
    fontSize: "96px",
    lineHeight: "112.03px",
    letterSpacing: "-1.5px",
  },
  h2: {
    fontFamily: "Circular",
    fontSize: "60px",
    lineHeight: "72px",
    letterSpacing: "-0.5px",
  },
  h3: {
    fontFamily: "CircularMedium",
    fontSize: "48px",
    lineHeight: "56.02px",
  },
  h4: {
    fontFamily: "CircularMedium",
    fontSize: "34px",
    lineHeight: "41.99px",
    letterSpacing: "0.25px",
  },
  h5: {
    fontFamily: "CircularMedium",
    fontSize: "24px",
    lineHeight: "32.02px",
  },
  h6: {
    fontFamily: "CircularBlack",
    fontSize: "20px",
    letterSpacing: "0.15px",
    lineHeight: "32px",
  },
  subtitle1: {
    fontFamily: "CircularMedium",
    fontSize: "16px",
    letterSpacing: "0.15px",
    lineHeight: "24px",
  },
  subtitle2: {
    fontFamily: "CircularMedium",
    fontSize: "14px",
    letterSpacing: "0.1px",
    lineHeight: "22px",
  },
  body1: {
    fontFamily: "Circular",
    fontSize: "16px",
    letterSpacing: "0.15px",
    lineHeight: "24px",
  },
  body2: {
    fontFamily: "Circular",
    fontSize: "14px",
    letterSpacing: "0.15px",
    lineHeight: "20px",
  },
  buttonLarge: {
    fontFamily: "CircularBlack",
    fontSize: "15px",
    letterSpacing: "0.46px",
    lineHeight: "26px",
    textTransform: "uppercase",
  },
  buttonMedium: {
    fontFamily: "CircularBlack",
    fontSize: "14px",
    letterSpacing: "0.46px",
    lineHeight: "24px",
    textTransform: "uppercase",
  },
  buttonSmall: {
    fontFamily: "CircularBlack",
    fontSize: "13px",
    letterSpacing: "0.46px",
    lineHeight: "22px",
    textTransform: "uppercase",
  },
  caption: {
    fontSize: "12px",
    letterSpacing: "0.4px",
    lineHeight: "20px",
    fontFamily: "CircularMedium",
  },
  overline: {
    fontFamily: "CircularMedium",
    fontSize: "12px",
    letterSpacing: "1px",
    lineHeight: "32px",
    textTransform: "uppercase",
  },
  inputLabel: {
    fontFamily: "CircularMedium",
    fontSize: "12px",
    letterSpacing: "0.15px",
    lineHeight: "12px",
  },
  helperText: {
    fontFamily: "Circular",
    fontSize: "11px",
    letterSpacing: "0.4px",
    lineHeight: "16px",
  },
  inputText: {
    fontFamily: "CircularMedium",
    fontSize: "16px",
    letterSpacing: "0.15px",
    lineHeight: "22px",
  },
  tooltip: {
    fontFamily: "CircularBlack",
    fontSize: "10px",
    lineHeight: "14px",
  },

  navbarIcon: {
    height: "32px",
    width: "32px",
    fontSize: "32px",
  },
};
